import React from "react";
import { alpha, useTheme } from "@mui/material/styles";
import { AlertTriangle, ArrowUpRight } from "@piiqtechnologies/svg-icons";
import { PeekAlert, PeekAvatar, PeekLink, PeekStack, PeekTypography } from "@piiqtechnologies/ui-components";
export const CheckoutBanner = ({ severity, title, message, onDismiss, onUpdateClick, updateText, }) => {
    const theme = useTheme();
    return (React.createElement(PeekAlert, { severity: severity, icon: React.createElement(PeekAvatar, { sx: { width: 48, height: 48, bgcolor: alpha(theme.palette[severity].main, 0.3) } },
            React.createElement(AlertTriangle, { width: 24, style: { color: theme.palette[severity].main } })), onClose: onDismiss, sx: {
            borderRadius: theme.spacing(1),
            alignItems: "flex-start",
            "& .MuiAlert-icon": { paddingTop: theme.spacing(0.8) },
        } },
        React.createElement(PeekStack, { spacing: 0.5 },
            React.createElement(PeekTypography, { variant: "h5", fontWeight: "fontWeightMedium" }, title),
            React.createElement(PeekStack, { direction: "row", gap: 0.5 },
                React.createElement(PeekTypography, { variant: "body1", color: "info" }, message),
                onUpdateClick && (React.createElement(PeekTypography, { variant: "body1" },
                    React.createElement(PeekLink, { onClick: onUpdateClick, sx: { cursor: "pointer" } },
                        updateText,
                        " ",
                        React.createElement(ArrowUpRight, null))))))));
};
export default CheckoutBanner;
